import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

import { Flexbox, ColorEnvironment, Font, Text } from './Styles';
import Cancel from './images/cancel.png';

import ActionCard from './ActionCard';
import ActionInfo from './ActionInfo';

import Locale from './models/Locale';

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    backgroundColor: 'rgba(0,0,0,0)'
  },
  cancel: {
    position: 'absolute',
    height: 50,
    width: 50,
    top: -100,
    right: -25,
    backgroundImage: `url(${Cancel})`
  }
});

class ActionToolbox extends Component {
  constructor(props) {
    super(props);
    this.state = { selectedAction: null };
  }

  render() {
    if (this.state.selectedAction !== null) {
      return(
        <ActionInfo onCancel={this.handleCancelAction.bind(this)} action={this.state.selectedAction}/>
      );
    } else {
      return(
        <div className={css(Flexbox.column, Flexbox.crossFill)}>
          <div className={css(Font.largeHeading, Text.heading, ColorEnvironment.transparent)}>{Locale.localized("Action Toolbox")}</div>
          <div className={css(Flexbox.row, Flexbox.wrap, Flexbox.axisFill, Flexbox.grow, ColorEnvironment.normal, styles.container)}>
            <div className={css(styles.cancel)} onClick={this.props.onClose} />
            {this.props.actions.map(action => {
              return <ActionCard key={action.description} small onSelect={this.handleShowAction.bind(this, action)} action={action}/>
            })}
            {this.props.actions.length === 0 &&
              <div className={css(Font.heading, Text.heading)}>{Locale.localized("You don't have any actions in your toolbox yet")}</div>
            }
          </div>
        </div>
      );
    }
  }

  handleShowAction(action) {
    this.setState({ selectedAction: action });
  }

  handleCancelAction() {
    this.setState({ selectedAction: null });
  }

  handleCancel() {
    this.props.onClose();
  }
}

export default ActionToolbox;



// WEBPACK FOOTER //
// ./src/ActionToolbox.js